export default [
  {
    path: "/cart",
    name: "order",
    component: () => import("./components/order-checkout.vue"),
    meta: {
      title: "Cart",
    },
  },
  {
    path: "/user/orders",
    name: "myOrder",
    component: () => import("./components/all-orders.vue"),
    meta: {
      title: "My Orders",
    },
  },
  {
    path: "/user/orders/:orderId",
    name: "orderDetail",
    component: () => import("./components/orders-detail.vue"),
    meta: {
      title: "Order Detail",
    },
    props: true
  }
  
];
